<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- force render tab because need validate all tab -->
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" v-if="props.visibleTabs" type="card">
            <TabPane key="Requestor" :tab="$t('views.request.requestor.title')" :forceRender="true">
                <RequestorForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataTempKey="refInspectionTemp"
                        userAuthorizeRole="INSPECTION"
                        :isLoading="isLoading"
                ></RequestorForm>
            </TabPane>
            <TabPane key="InspectionInfo" :tab="$t('views.request.inspectionInfo.title')" :forceRender="true">
                <InspectionInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refInspectionTemp"
                        :isLoading="isLoading"
                ></InspectionInfoForm>
                <InformProductTab
                        v-if="data.useForm.modelRef.refInspectionTemp?.refInformTemp?.id"
                        :menuContext="menuContext"
                        :viewOnly="true"
                        :dataProp="data"
                        dataKey="refInspectionTemp.refInformTemp"
                        dataTempKey="refInspectionTemp.refInformTemp"
                        :isLoading="isLoading"
                        :request="data.useForm.modelRef.refInspectionTemp.refInformTemp"
                        :visibleCardTitle="true"
                        :viewOnlyInspection="viewOnly"
                        :fetchCriteria="{ fetched: true }"
                        :balanceOnly="true"
                ></InformProductTab>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refInspectionTemp"
                        :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
    import { Card, Form, Tabs } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../app.logic";
    import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";

    export default defineComponent({
        components: {
            Card,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
            RequestorForm: defineAsyncComponent(() => import("../../storage-location/request/requestor/RequestorForm")),
            InspectionInfoForm: defineAsyncComponent(() => import("./inspection-info/InspectionInfoForm")),
            AttachmentForm: defineAsyncComponent(() => import("../../storage-location/request/attachment/AttachmentForm")),
            InformProductTab: defineAsyncComponent(() => import("../../inform/request/inform-product/InformProductTab")),
            RemarkInfoForm: defineAsyncComponent(() => import("../../remark/RemarkInfoForm")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "inspection-requests" },
            viewOnly: { default: false },
            form: {},
            id: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true },
            visibleTabs: { default: true },
            visibleRequestForm: { default: true },
            forceDefault: { default: false },
        },
        setup(props) {
            // eslint-disable-next-line vue/no-mutating-props
            const route = useRoute();
            const id = props.id ? props.id : props.form ? props.form.id : route.params?.id;
            const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ data }));
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                callOnClickModalOk
            };
        }
    });
</script>
